/* eslint-disable react/prop-types */

import React, { useContext } from 'react';

import { navigate } from 'gatsby';

import { Checkout, CartContext } from '@bluefin/components';

import './Checkout.css';

function EcommerceCheckout() {
  const cartContext = useContext(CartContext);
  const { cart } = cartContext;

  return (
    <Checkout onReturnToCatalogPage={() => navigate(-1)} cartHook={cart}>
      <div className="stripe-checkout-container">
        <Checkout.Stripe />
      </div>
    </Checkout>
  );
}

export default EcommerceCheckout;
